import groupBy from 'lodash/groupBy';
import keyBy from 'lodash/keyBy';
import orderBy from 'lodash/orderBy';
import { createSelector } from 'reselect';

import { ApplicationRootState } from 'store/types';
import { CountryId } from 'types/models/country';
import { StateAbbreviation } from 'types/models/state';

const selectStates = (state: ApplicationRootState) => state.states;

const selectStatesAsArray = createSelector(selectStates, (states) =>
  orderBy(Object.values(states), 'name')
);

const selectStatesGroupedByCountryId = createSelector(
  selectStatesAsArray,
  (statesAsArray) => groupBy(statesAsArray, 'countryId')
);

const makeSelectStateByAbbreviation = (stateAbbreviation: StateAbbreviation) =>
  createSelector(
    selectStates,
    (states) => keyBy(Object.values(states), 'abbreviation')[stateAbbreviation]
  );

const makeSelectStatesByCountryId = (countryId: CountryId | undefined) =>
  createSelector(selectStatesGroupedByCountryId, (statesGroupedByCountryId) =>
    countryId ? statesGroupedByCountryId[countryId] : undefined
  );

export {
  selectStates,
  selectStatesAsArray,
  selectStatesGroupedByCountryId,
  makeSelectStateByAbbreviation,
  makeSelectStatesByCountryId
};
